import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { PageImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/pageImpressionTrackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo,
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsPageImpression
    extends GoogleAnalyticsMinimumDataset {}

const getGoogleAnalyticsPageImpression = (
    data: TypedAnalyticsEvent<PageImpressionTrackingInfo>,
): GoogleAnalyticsPageImpression => {
    return {
        event: GoogleAnalyticsEvents.PageImpression,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
    };
};

export { getGoogleAnalyticsPageImpression };
